import React, { lazy } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { haptics } from '../../lib/utils/haptics';
import { SmartImage } from '../shared/SmartImage';
export function ShopByCategory() {
  const navigate = useNavigate();
  const categories = [{
    id: 'medicines',
    name: 'Medicines',
    slug: 'medicines',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2FBiotin-Trending.jpg&w=384&q=100'
  }, {
    id: 'vitamins-supplements',
    name: 'Vitamins',
    slug: 'vitamins-supplements',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2FSporter-brand-11.jpg&w=384&q=100'
  }, {
    id: 'beauty-skin-care',
    name: 'Beauty',
    slug: 'beauty-skin-care',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2Fwomen-2023.jpg&w=640&q=100'
  }, {
    id: 'baby-mother-care',
    name: 'Baby Care',
    slug: 'baby-mother-care',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2Fkids-2023.jpg&w=640&q=100'
  }, {
    id: 'personal-care',
    name: 'Personal Care',
    slug: 'personal-care',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2FTRN24-Personal-Care-.jpg&w=384&q=100'
  }, {
    id: 'herbal-natural',
    name: 'Herbal',
    slug: 'herbal-natural',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2FTRN24-Natures-Way.jpg&w=384&q=100'
  }, {
    id: 'medical-devices',
    name: 'Devices',
    slug: 'medical-devices',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2Fmen-2023.jpg&w=640&q=100'
  }, {
    id: 'first-aid',
    name: 'First Aid',
    slug: 'first-aid',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2Fsports-2023.jpg&w=640&q=100'
  }, {
    id: 'sports-nutrition',
    name: 'Sports',
    slug: 'sports-nutrition',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2FTRN24-Sports-Nutrition.jpg&w=384&q=100'
  }, {
    id: 'wellness',
    name: 'Wellness',
    slug: 'wellness',
    image: 'https://www.sporter.com/_next/image/?url=https%3A%2F%2Fwww.sporter.com%2Fmedia%2Fwysiwyg%2FTRN24-Wellness.jpg&w=384&q=100'
  }];
  return <div className="container mx-auto px-4" data-id="element-2083" data-mp="24jd3kwhtbu7t">
      <div className="flex items-center justify-between mb-4" data-id="element-2084" data-mp="24i1z0ugjmifn">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900" data-id="element-2085" data-mp="2s8o6ajiq3yol">
          Shop by Category
        </h2>
        <button onClick={() => navigate('/categories')} className="text-sm text-[#1E2B55] hover:underline font-medium" data-id="element-2086" data-mp="2x17jhfdi0rsv">
          View All
        </button>
      </div>

      {/* Desktop Grid */}
      <div className="hidden md:grid grid-cols-6 lg:grid-cols-8 xl:grid-cols-10 gap-3" data-id="element-2087" data-mp="gk9lfccgs47s">
        {categories.map((category, idx) => <motion.button key={category.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.03,
        duration: 0.4
      }} onClick={() => {
        haptics.impact();
        navigate(`/category/${category.slug}`);
      }} className="flex flex-col items-center group cursor-pointer" data-id="element-2088" data-mp="qbnh191aojvn" data-mpi={idx}>
            <div className="w-full aspect-square rounded-2xl overflow-hidden mb-2 transition-all group-hover:scale-105 group-hover:shadow-lg" data-id="element-2089" data-mp="1j1madgmiv364">
              <img src={category.image} alt={category.name} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-2090" data-mp="2ecu6nz0k01uh" />
            </div>
            <span className="text-xs md:text-sm font-bold text-center text-gray-900 group-hover:text-[#1E2B55] transition-colors" data-id="element-2091" data-mp="2sbbqhlnc8u74">
              {category.name}
            </span>
          </motion.button>)}
      </div>

      {/* Mobile Horizontal Scroll */}
      <div className="md:hidden -mx-4" data-id="element-2092" data-mp="319e20v4p758n">
        <div className="overflow-x-auto scrollbar-hide px-4" data-id="element-2093" data-mp="361xc3i46fi8p">
          <div className="flex gap-4 pb-2" data-id="element-2094" data-mp="364jkfjyw61rz">
            {categories.map((category, idx) => <motion.button key={category.id} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.03,
            duration: 0.4
          }} onClick={() => {
            haptics.impact();
            navigate(`/category/${category.slug}`);
          }} className="flex flex-col items-center group cursor-pointer flex-shrink-0 w-24" data-id="element-2095" data-mp="3b34knje58lgf" data-mpi={idx}>
                <div className="w-24 h-24 rounded-2xl overflow-hidden mb-2 transition-all active:scale-95 group-hover:shadow-lg" data-id="element-2096" data-mp="1n3sqe9khxu69">
                  <img src={category.image} alt={category.name} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-2097" data-mp="1ibr6q2l01167" />
                </div>
                <span className="text-xs font-bold text-center text-gray-900 group-hover:text-[#1E2B55] transition-colors" data-id="element-2098" data-mp="261v8s5ijgsv3">
                  {category.name}
                </span>
              </motion.button>)}
          </div>
        </div>
      </div>
    </div>;
}